<template>
  <b-container
  fluid
  class="assets-and-maneuver"
  >
    <b-row>
      <label class="assets-and-maneuver__input-group-title">
        {{ $t('fields.asset.report-asset') }}
      </label>
    </b-row>
    <b-row align-h="between">
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group>
          <label
          > {{ $t('fields.asset.asset-type') }}*
          </label>
            <s-select
              v-model="filterOptions.assetType"
              value-field="id"
              text-field="name"
              :options="assetTypes"
              :disabled="!noManeuverSelected"
              @change="assetTypeChanged"
            />
        </b-form-group>
      </b-col>
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group>
          <tag-options-input
            class="mb-3"
            :label="$t('entities.asset')"
            :tag-label="'name'"
            :track-tag-by="'id'"
            :tags="assets"
            :selected-items.sync="filterOptions.assets"
            :options-custom-label="$t('reports.filters.options.all-assets')"
            :disabled="!filterOptions.assetType"
            :loading="loadingAssets"
            :is-required-field="isAssetFieldRequired"
            :dropdown-direction="dropdownDirection"
            @update:selectedItems="updateFilter"
            @remove-item="updateFilter"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group>
            <tag-options-input
              class="mb-3"
              :label="$t('fields.module.label')"
              :tag-label="'name'"
              :track-tag-by="'id'"
              :tags="modules"
              :selected-items.sync="filterOptions.modules"
              :options-custom-label="$t('reports.filters.options.all-assets')"
              :disabled="modules.length === 1 || modules.length === 0"
              :loading="loadingModules"
              :is-required-field="false"
              :dropdown-direction="dropdownDirection"
              @update:selectedItems="updateFilter"
              @remove-item="updateFilter"
            />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <label class="assets-and-maneuver__input-group-title"
      > {{ $t('reports.report-the-maneuvers') }}
      </label>
    </b-row>
    <b-row align-h="between">
      <b-col
        md="6"
        sm="12"
        order="0"
      >
        <b-form-group>
          <tag-options-input
            class="mb-3"
            :label="$t('fields.asset.select-maneuvers-types')"
            :tag-label="'name'"
            :track-tag-by="'id'"
            :tags="maneuverTypes"
            :selected-items.sync="filterOptions.maneuverTypes"
            :options-custom-label="$t('reports.filters.options.all-types-maneuvers')"
            :disabled="!filterOptions.assetType"
            :loading="loadingManeuverType"
            :is-required-field="isAssetFieldRequired"
            :dropdown-direction="dropdownDirection"
            @update:selectedItems="onUpdateManeuverType"
            @remove-item="updateFilter"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="3"
        sm="6"
        cols="12"
        order="2"
        order-md="1"
      >
        <label
        > {{ $t('fields.general.initial-date') }}
        </label>
        <s-input-date-picker
          @input="saveFilterBackup"
          v-model.lazy="initial.date"
          @lazy-blur-native-proxy="validateDate"
        />
      </b-col>
      <b-col
        md="3"
        sm="6"
        cols="12"
        order="3"
        order-md="2"
      >
        <label
        > {{ $t('fields.general.initial-time') }}
        </label>
        <s-input-time
          step="1"
          v-model="initial.time"
          @input="saveFilterBackup"
        />
      </b-col>
      <b-col
        md="6"
        sm="12"
        class="mt-3 mt-sm-0"
        order="1"
        order-md="3"
      >
        <b-form-group>
          <tag-options-input
            class="mb-3"
            :label="$t('fields.asset.select-oscillographs-subtypes')"
            :tag-label="'name'"
            :track-tag-by="'id'"
            :tags="oscillographySubtypes"
            :selected-items.sync="filterOptions.maneuverSubTypes"
            :options-custom-label="$t('reports.filters.options.all-subtipe-oscillography')"
            :disabled="!filterOptions.maneuverTypes.length"
            :loading="loadingManeuverSubType"
            :is-required-field="isAssetFieldRequired"
            :dropdown-direction="dropdownDirection"
            @update:selectedItems="updateFilter"
            @remove-item="updateFilter"
          >
            <template #label-right>
              <s-icon
                name="hint"
                class="ml-1"
                v-b-tooltip.hover.right
                :title="$t('fields.asset.subtypes-tooltip-hint')"
                tabindex="0"
                @click.native="showSubtypeHelpModal = true"
                style="cursor:pointer;font-size:16px;vertical-align:middle;"
                @click="showSubtypeHelpModal = true"
              />
            </template>
          </tag-options-input>
        </b-form-group>
      </b-col>
      <b-col
        md="3"
        sm="6"
        cols="12"
        order="4"
      >
        <label
          for="company"
          class="network-status-advanced-filters__input"
        > {{ $t('fields.general.final-date') }}
        </label>
        <s-input-date-picker
          @input="saveFilterBackup"
          v-model="final.date"
          @lazy-blur-native-proxy="validateDate"
        />
      </b-col>
      <b-col
        md="3"
        sm="6"
        cols="12"
        order="5"
      >
        <label
          for="regional"
          class="network-status-advanced-filters__input"
        > {{ $t('fields.general.final-time') }}
        </label>
        <s-input-time
          step="1"
          v-model="final.time"
          @input="saveFilterBackup"
        />
      </b-col>
    </b-row>
    <b-row class="mt-3" align-h="end">
      <b-col
        sm="12"
        md="auto"
      >
        <b-btn
          block
          @click="cleanFilters"
        > {{ $t('general.clean-filters') }}
        </b-btn>
      </b-col>
      <b-col
        sm="12"
        md="auto"
        class="my-3 my-md-0"
      >
        <s-loading-button
          block
          :loading="loadHandler"
          :disabled="missingFields"
          variant="primary"
          v-s-trigger:click="search"
        > {{ $t('general.search') }}
        </s-loading-button>
      </b-col>
    </b-row>
    <subtype-help-modal
      v-model="showSubtypeHelpModal"
    />
  </b-container>
</template>
<style lang="sass" scoped>
  .assets-and-maneuver
    &__input-group-title
      color: var(--color-secondary)
</style>
<script>
import OscillographyService from '@/domain/services/generalPanel/reports/oscillography';
import AssetService from '@/domain/services/asset';
import TagOptionsInput from '@/components/inputs/TagOptionsInput';
import {
  joinISODateAndTimeString,
  isGreater,
} from '@/services/dateTime/datetimeService';
import SubtypeHelpModal from './helpModal/index';

export default {
  name: 'AssetAndManeuverFilters',
  props: {
    noManeuverSelected: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: [Boolean, Number],
    },
    maneuvers: {
      type: Array,
      default: () => [],
    },
    modules: {
      type: Array,
      default: () => [],
    },
    filterBackup: {
      type: Object,
      required: true,
    },
    installationFilter: {
      type: Array,
      required: true,
      default: () => [],
    },
    isAssetFieldRequired: {
      type: Boolean,
      default: true,
    },
    dropdownDirection: {
      type: String,
      default: '',
    },
  },
  components: {
    TagOptionsInput,
    SubtypeHelpModal,
  },
  data: vm => ({
    showModalVariables: false,
    localLoading: false,
    loadingManeuverType: false,
    assetTypes: [
      {
        id: null,
        name: vm.$t('general.select'),
      },
    ],
    maneuverTypes: [],
    modules: [],
    assets: [],
    filterOptions: {
      assetType: null,
      modules: [],
      assets: [],
      maneuverTypes: [],
      maneuverSubTypes: [],
    },
    initial: {
      date: null,
      time: '00:00:00',
    },
    final: {
      date: null,
      time: '23:59:59',
    },
    loadingAssets: false,
    loadingManeuverSubType: false,
    loadingModules: false,
    showSubtypeHelpModal: false,
  }),
  computed: {
    loadHandler() {
      return Boolean(this.localLoading) || Boolean(this.loading);
    },
    registeredOscillographs() {
      return this.maneuvers.map(({ assetModuleId, oscillographyId }) => ({
        assetModuleId,
        oscillographyId,
      }));
    },
    mappedFilterPayload() {
      const {
        assets,
        maneuverTypes,
        maneuverSubTypes,
        // eslint-disable-next-line no-shadow
        modules,
      } = this.filterOptions;
      const { registeredOscillographs } = this;
      return {
        ...this.filterOptions,
        registeredOscillographs,
        assets: this.idMapper(assets),
        maneuverTypes: this.idMapper(maneuverTypes),
        maneuverSubTypes: this.idMapper(maneuverSubTypes),
        modules: this.idMapper(modules),
      };
    },
    oscillographySubtypes() {
      const flattenSubtypes = this.filterOptions.maneuverTypes
        .map(({ subTypes }) => subTypes)
        .reduce((item, index) => item.concat(index), []);
      const map = new Map();
      flattenSubtypes.map((item = {}) => {
        if (map.has(item.id)) return null;
        return map.set(item.id, item);
      });
      return [...map.values()];
    },
    missingFields() {
      const requiredFields = {
        assetType: this.filterOptions.assetType,
        assets: this.filterOptions.assets.length,
        modules: this.filterOptions.modules.length > 0,
        maneuverTypes: this.filterOptions.maneuverTypes.length,
        maneuverSubTypes: this.filterOptions.maneuverSubTypes.length,
      };
      return Boolean(Object.values(requiredFields).filter(item => !item).length);
    },
    initialDateAndTime() {
      const {
        date,
        time,
      } = this.initial;
      return joinISODateAndTimeString(date, time || '00:00:00');
    },
    finalDateAndTime() {
      const {
        date,
        time,
      } = this.final;
      return joinISODateAndTimeString(date, time || '23:59:59');
    },
  },
  created() {
    this.setTimeBackup();
    this.getAssetTypes();
    this.getAssets().then(() => this.handleGridSelection(this.assets));
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    'filterOptions.assets'(newAssets) {
      if (newAssets.length > 0 && this.filterOptions.modules.length === 0) {
        this.getModules();
      }
      if (newAssets.length === 0) {
        this.filterOptions.modules = [];
      }
    },
  },
  methods: {
    handleGridSelection(assets) {
      this.$emit('handle-assets', assets);
    },
    validateDate() {
      const { initialDateAndTime, finalDateAndTime } = this;
      if (!this.initial.date || !this.final.date) return;
      if (isGreater(finalDateAndTime, initialDateAndTime)) return;
      this.$pushAlert({
        code: 'MA006',
      });
    },
    setTimeBackup() {
      const {
        final = {},
        initial = {},
      } = this.filterBackup;
      this.initial.date = initial.date;
      this.initial.time = initial.time;
      this.final.date = final.date;
      this.final.time = final.time;
    },
    handleNoManeuverTypes() {
      if (this.filterOptions.maneuverTypes.length) return;
      this.filterOptions.maneuverSubTypes = [];
    },
    saveFilterBackup() {
      this.handleNoManeuverTypes();
      const {
        initialDateAndTime,
        finalDateAndTime,
        initial,
        final,
      } = this;
      const payload = {
        ...this.mappedFilterPayload,
        initialDateAndTime,
        finalDateAndTime,
        initial,
        final,
      };
      this.$emit('save-filter-options', payload);
      if (this.mappedFilterPayload.assetType
        && this.mappedFilterPayload.maneuverTypes?.length > 0
        && this.mappedFilterPayload.modules?.length > 0) {
        this.$emit('initialize-references', payload);
      }
      return payload;
    },
    idMapper(list) {
      if (!list || !list.length) return [];
      return list.map(({ id }) => id);
    },
    assetTypeChanged() {
      this.filterOptions.assets = [];
      this.filterOptions.maneuverTypes = [];
      this.filterOptions.maneuverSubTypes = [];
      this.saveFilterBackup();
      this.getManeuverTypes();
      this.$nextTick(() => {
        this.getAssets();
      });
    },
    caseNullHandler(list, text) {
      return [
        {
          id: null,
          name: text,
        },
        ...list,
      ];
    },
    search() {
      this.$emit('search', this.saveFilterBackup());
    },
    getAssetTypes() {
      this.localLoading += 1;
      AssetService
        .getAssetTypes()
        .then((response) => {
          this.assetTypes = this
            .caseNullHandler(response, this.$t('general.select'));
          this.assetTypes.forEach((item) => {
            if (item.id === this.filterBackup.assetType) {
              this.$set(this.filterOptions, 'assetType', item.id);
            }
          });
          this.getManeuverTypes();
        })
        .finally(() => {
          this.localLoading -= 1;
        });
    },
    getManeuverTypes() {
      const maneuverIds = this.filterBackup.maneuverTypes || [];
      const assetTypeId = this.filterOptions.assetType;
      if (!assetTypeId) return;
      this.localLoading += 1;
      this.loadingManeuverType = true;
      AssetService
        .getManeuverTypes(assetTypeId)
        .then((response) => {
          this.maneuverTypes = response;
          this.maneuverTypes.forEach((maneuver) => {
            if (!maneuverIds.includes(maneuver.id)) return;
            this.filterOptions.maneuverTypes.push(maneuver);
          });
          if (this.filterOptions.maneuverTypes.length) {
            this.filterOptions.maneuverSubTypes = this.oscillographySubtypes
              .filter(({ id }) => (this.filterBackup.maneuverSubTypes || []).includes(id));
          }
        })
        .finally(() => {
          this.localLoading -= 1;
          this.loadingManeuverType = false;
        });
    },
    getModules() {
      this.localLoading += 1;
      this.loadingModules = true;
      return OscillographyService
        .getModules(this.idMapper(this.filterOptions.assets))
        .then((response) => {
          const backupModuleIds = (this.filterBackup.modules || [])
            .map(moduleId => moduleId.toUpperCase());
          const selectedModules = response.filter(
            module => backupModuleIds.includes(module.id.toUpperCase()),
          );

          if (selectedModules.length > 0) {
            this.filterOptions.modules = selectedModules;
          } else if (response.length === 1) {
            this.filterOptions.modules = [response[0]];
          }
          this.modules = response;
        })
        .finally(() => {
          this.localLoading -= 1;
          this.loadingModules = false;
        });
    },
    getAssets() {
      const backupAssetIds = this.filterBackup.assets || [];
      this.localLoading += 1;
      this.loadingAssets = true;
      return OscillographyService
        .getAssets({
          assetTypeId: this.filterOptions.assetType || this.filterBackup.assetType,
          installationsIds: this.installationFilter,
        })
        .then((response) => {
          this.assets = response;
          this.assets.forEach((asset) => {
            const adjustBackupAssetIds = backupAssetIds.map((x) => x.toUpperCase());
            if (!adjustBackupAssetIds.includes(asset.id)) return;
            this.filterOptions.assets.push(asset);
          });
        })
        .finally(() => {
          this.localLoading -= 1;
          this.loadingAssets = false;
        });
    },
    cleanFilters() {
      this.filterOptions = {
        ...this.filterOptions,
        maneuverTypes: [],
        maneuverSubTypes: [],
      };
      this.initial = {
        date: null,
        time: '00:00:00',
      };
      this.final = {
        date: null,
        time: '23:59:59',
      };
      this.$emit('clear-grid');
    },
    updateFilter() {
      const newFilter = {
        modules: this.mapArrayIds(this.filterOptions.modules),
        assets: this.mapArrayIds(this.filterOptions.assets),
        maneuverTypes: this.mapArrayIds(this.filterOptions.maneuverTypes),
        maneuverSubTypes: this.mapArrayIds(this.filterOptions.maneuverSubTypes),
      };
      this.$emit('update:filter', { ...this.filterOptions, ...newFilter });
      this.updateFilterObjects();
    },
    updateFilterObjects() {
      const newFilter = {
        assetType: this.filterOptions.assetType,
        assets: this.filterOptions.assets,
        modules: this.filterOptions.modules,
        maneuverTypes: this.filterOptions.maneuverTypes,
        maneuverSubTypes: this.filterOptions.maneuverSubTypes,
      };
      this.$emit('update:filter-objects', { ...this.filterOptions, ...newFilter });
    },
    async onUpdateManeuverType() {
      if (!(this.filterOptions.maneuverTypes || []).length) {
        this.onRemoveAllManeuverSubType();
      } else {
        this.filterSelectedSubtypesByManeuverTypes();
      }
      this.updateFilter();
    },
    onRemoveAllManeuverSubType() {
      this.filterOptions.maneuverSubTypes = [];
    },
    filterSelectedSubtypesByManeuverTypes() {
      const validSubtypeIds = new Set();
      this.filterOptions.maneuverTypes.forEach(maneuverType => {
        if (maneuverType.subTypes) {
          maneuverType.subTypes.forEach(subType => {
            validSubtypeIds.add(subType.id);
          });
        }
      });

      this.filterOptions.maneuverSubTypes = this.filterOptions.maneuverSubTypes.filter(
        selectedSubType => validSubtypeIds.has(selectedSubType.id),
      );
    },
    mapArrayIds(array = []) {
      return array.map(item => item.id?.toUpperCase());
    },
  },
};
</script>
<style>
.advanced-settings-button {
  display: flex;
  align-items: center;
  font-weight: bold;
}
</style>
